import {createSelector} from 'reselect'

export const getSimilarProductsLoading = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.detail && state.vehicleParts.detail.similarProducts && state.vehicleParts.detail.similarProducts.isLoading ? state.vehicleParts.detail.similarProducts.isLoading : false,
  isLoading => isLoading
)